
import { stats } from '../../../mocks/tattoos';

export default function ArtistSection() {
  return (
    <section id="artista" className="py-16 md:py-24 bg-neutral-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-2 relative">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/3504d181e6e6ca7e4f9e1b4381e9ee00.jpeg"
                alt="Daro - Tatuador Profesional"
                className="w-full h-[400px] md:h-[700px] object-cover object-top"
                style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%)' }}
              />
              
              <div className="absolute top-4 md:top-6 right-4 md:right-6 flex flex-col gap-2 md:gap-3">
                <div className="bg-black/70 backdrop-blur-sm px-3 md:px-4 py-1.5 md:py-2 text-white text-xs font-medium" style={{ clipPath: 'polygon(8px 0, 100% 0, 100% 100%, 0 100%, 0 8px)' }}>
                  PROFESIONAL
                </div>
                <div className="bg-black/70 backdrop-blur-sm px-3 md:px-4 py-1.5 md:py-2 text-white text-xs font-medium" style={{ clipPath: 'polygon(8px 0, 100% 0, 100% 100%, 0 100%, 0 8px)' }}>
                  CERTIFICADO
                </div>
                <div className="bg-black/70 backdrop-blur-sm px-3 md:px-4 py-1.5 md:py-2 text-white text-xs font-medium" style={{ clipPath: 'polygon(8px 0, 100% 0, 100% 100%, 0 100%, 0 8px)' }}>
                  HIGIENE 100%
                </div>
              </div>
            </div>

            <div className="relative lg:absolute -bottom-4 lg:-bottom-8 left-4 right-4 lg:left-auto lg:-right-8 grid grid-cols-3 gap-4 bg-neutral-900 p-4 md:p-6 shadow-xl border border-neutral-700 mt-4 lg:mt-0" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}>
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white mb-1" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                    {stat.number}
                  </div>
                  <div className="text-xs text-neutral-400 uppercase tracking-wide">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 mt-8 lg:mt-0">
            <div className="bg-neutral-900 p-6 md:p-12 relative border border-neutral-700" style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%)' }}>
              <div className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 w-1 h-32 bg-neutral-600"></div>

              <h2 className="text-neutral-500 text-sm font-bold uppercase tracking-widest mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Conoce a Daro
              </h2>

              <h3 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                Pasión por el Arte del Tatuaje
              </h3>

              <div className="space-y-4 md:space-y-6 text-neutral-400 leading-relaxed text-sm md:text-base">
                <p>
                  Con más de 8 años de experiencia en el mundo del tatuaje, me especializo en crear piezas únicas que cuentan historias. Mi enfoque principal es el <strong className="text-white">Mini Realismo</strong> y el <strong className="text-white">Realismo</strong>, técnicas que me permiten capturar cada detalle con precisión.
                </p>
                <p>
                  En Daro Tattoo, cada cliente es único y cada tatuaje es una obra de arte personalizada. Trabajo estrechamente contigo desde el diseño inicial hasta el resultado final, asegurándome de que tu visión se convierta en realidad.
                </p>
                <p>
                  La higiene y profesionalidad son mis prioridades. Utilizo únicamente material esterilizado y desechable, siguiendo los más altos estándares de seguridad en la industria.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mt-8 md:mt-10">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-contrast-2-line text-2xl text-neutral-500"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Realismo</h4>
                    <p className="text-neutral-500 text-sm">Detalles fotográficos</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-palette-line text-2xl text-neutral-500"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Mini Realismo</h4>
                    <p className="text-neutral-500 text-sm">Precisión en pequeño formato</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shape-line text-2xl text-neutral-500"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Geométrico</h4>
                    <p className="text-neutral-500 text-sm">Precisión matemática</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-brush-line text-2xl text-neutral-500"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Cover-ups</h4>
                    <p className="text-neutral-500 text-sm">Renovación artística</p>
                  </div>
                </div>
              </div>

              <a 
                href="https://www.instagram.com/Daro_tattoo_" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block mt-8 md:mt-10 px-6 md:px-8 py-3 bg-neutral-700 text-white font-medium hover:bg-neutral-600 transition-all cursor-pointer whitespace-nowrap text-xs md:text-sm"
                style={{ clipPath: 'polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px)' }}
              >
                <i className="ri-instagram-line mr-2"></i>
                SÍGUEME EN INSTAGRAM @Daro_tattoo_
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
